import { createSelector } from 'reselect';

import { selectQuery } from 'rdx/router';
import { GlobalAppState } from 'rdx/state';

import { filterByName, isOutOfStock } from './utils';

export const selectMenu = (state: GlobalAppState) => state.menu.data;

export const selectMenuDishesEntities = createSelector(selectMenu, (menu) => menu.entities.dish);

export const selectMenuOptionsEntities = createSelector(selectMenu, (menu) => menu.entities.option);

export const selectOutOfStockMenuItemIds = createSelector(selectMenu, (menu) => {
  const outOfStockDishes = menu.result.dishes.filter((menuId) =>
    isOutOfStock(menu.entities.dish[menuId]),
  );

  const outOfStockOptions = menu.result.options.filter((menuId) =>
    isOutOfStock(menu.entities.option[menuId]),
  );

  return outOfStockDishes.concat(outOfStockOptions);
});

export const selectVisibleMenuItemIds = createSelector(
  selectMenu,
  selectOutOfStockMenuItemIds,
  selectQuery,
  (menu, outOfStockMenuItemIds, query) => {
    const { dishes, options } = menu.result;
    const { search, showSoldOutItems, selectedCategoryId } = query;

    let menuItemIds = showSoldOutItems === 'true' ? outOfStockMenuItemIds : [...dishes, ...options];

    if (search) {
      menuItemIds = menuItemIds.filter((menuId) => {
        const menuItem = menu.entities.dish[menuId] || menu.entities.option[menuId];
        return menuItem && filterByName(search, menuItem.name);
      });
    }

    if (!search && showSoldOutItems !== 'true') {
      menuItemIds =
        selectedCategoryId === 'options'
          ? menu.result.options || []
          : menu.entities.category[Number(selectedCategoryId)]?.dishes || [];
    }

    return menuItemIds;
  },
);

export const selectMenuItemById = (state: GlobalAppState, id: number) =>
  state.menu.data.entities.dish[id] || state.menu.data.entities.option[id];

export const selectMenuRequestState = (state: GlobalAppState) => state.menu.fetchingState;

export const selectMenuUpdateRequestState = (state: GlobalAppState) =>
  state.menu.updateRequestState;

export const selectMenuCategoriesEntities = createSelector(
  selectMenu,
  (menu) => menu.entities.category,
);
